<h1 class="h5">Geschäftseinheit auswählen</h1>

@if (customers(); as customers) {
  @if (customers) {
    <ui-customer-autocomplete
      (selectChange)="customerSelected($event)"
      [customer]="current()"
      [customers]="customers"
      label="Geschäftseinheit (Kunden-Nr. | Firma | Adresse)"
    ></ui-customer-autocomplete>
  }
}
<ui-button (click)="changeContext()" buttonStyle="filled">Geschäftseinheit wechseln</ui-button>
